import API from '../../../API/api';
import { setCsrfTokenKeyValue, isCsrfTokenExists } from '../../../utilities/csrf_token_provider';

export const fetchCsrfToken = async () => {
    if (isCsrfTokenExists()) {
        return Promise.resolve();
    }

    try {
        let response;
        response = await API.GET({
            apiPath: '/api/v2/token/',
            dataType: 'json',
        });

        setCsrfTokenKeyValue(response.keyName, response.keyValue, response.valueName, response.valueValue);
        return Promise.resolve(response);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};
